
import Vue from 'vue';
import Banner from '../components-pc/Banner.vue';
import HomeFooter from '../components-pc/HomeFooter.vue';
import More from '../components-pc/More.vue';
import NewsLayout from '../components-pc/NewsLayout.vue';
import PcPageLoading from '../components-pc/PcPageLoading.vue';
import { getBaseInfo, getNewsColumn } from '../api';

const CARD_NEWS_PAGE_SIZE = 10;

export default Vue.extend({
  name: 'NewsPc',
  components: {
    Banner,
    HomeFooter,
    More,
    NewsLayout,
    PcPageLoading,
  },
  data() {
    return {
      activeNewsIndex: 0,
      pageLoading: false,
      topNewsList: [] as any[],
      cardNewsList: [] as any[],
      cardNewsColumnId: null as any,
      cardNewsPage: 0,
      cardNewsLoading: false,
      cardNewsFinished: false,
    };
  },
  created() {
    this.initPageData();
  },
  mounted() {
    window.addEventListener('scroll', this.handlePageScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handlePageScroll);
  },
  methods: {
    async initPageData() {
      this.pageLoading = true;
      try {
        await this.fetchBaseInfo();
        await this.fetchCardNewsList(1);
      } finally {
        this.pageLoading = false;
      }
    },
    async fetchBaseInfo() {
      try {
        const res: any = await getBaseInfo();
        this.cardNewsColumnId = res.data && res.data.classId;
      } catch (err) {
        console.error('基础信息获取失败：', err);
      }
    },
    async fetchCardNewsList(page: number) {
      if (
        this.cardNewsLoading ||
        this.cardNewsFinished ||
        this.cardNewsColumnId === null ||
        this.cardNewsColumnId === undefined ||
        this.cardNewsColumnId === ''
      ) {
        return;
      }

      this.cardNewsLoading = true;

      try {
        const res: any = await getNewsColumn({
          page,
          pageSize: CARD_NEWS_PAGE_SIZE,
          columnId: this.cardNewsColumnId,
        });
        const newsList = (res.data && res.data.list) || [];

        if (!newsList.length) {
          this.cardNewsFinished = true;
          return;
        }

        if (page === 1) {
          this.topNewsList = newsList.slice(0, 3);
          this.activeNewsIndex = 0;
        }

        const cardNewsList = page === 1 ? newsList.slice(3) : newsList;

        this.cardNewsPage = page;
        this.cardNewsList =
          page === 1 ? cardNewsList : this.cardNewsList.concat(cardNewsList);

        this.$nextTick(() => {
          this.handlePageScroll();
        });
      } catch (err) {
        console.error('新闻列表获取失败：', err);
      } finally {
        this.cardNewsLoading = false;
      }
    },
    getNewsImageUrl(data: any): string {
      const imageUrl =
        data.imageUrl ||
        data.titlePic ||
        data.titlepic ||
        data.picUrl ||
        data.coverUrl ||
        data.cover;

      if (Array.isArray(imageUrl)) {
        return imageUrl[0] || '';
      }

      return imageUrl || '';
    },
    formatCardNewsDate(value: any): string {
      if (!value) {
        return '';
      }

      const time = Number(value);
      if (!Number.isNaN(time)) {
        const date = new Date(String(value).length === 10 ? time * 1000 : time);

        if (!Number.isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');

          return `${year}.${month}.${day}`;
        }
      }

      return String(value).split(' ')[0].replace(/-/g, '.');
    },
    getCardThumbStyle(item: any) {
      if (!item.imageUrl.length) {
        return {};
      }

      return {
        backgroundImage: `url(${item.imageUrl[0] || ''})`,
      };
    },
    handlePageScroll() {
      if (this.cardNewsLoading || this.cardNewsFinished) {
        return;
      }

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const pageHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
      );

      if (pageHeight - scrollTop - viewportHeight <= 160) {
        this.fetchCardNewsList(this.cardNewsPage + 1);
      }
    },
    goCardNewsDetail(item: any) {
      if (item.newsPath) {
        window.open(
          `https://www.cqcb.com` + item.newsPath.replace(/^\/?\d+/, ''),
          '_blank',
        );
      }
    },
    scrollToCards() {
      const cards = this.$refs.cards as HTMLElement | undefined;
      if (cards && cards.scrollIntoView) {
        cards.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
});
